// Copyright (c) Move Closer 2022.

import { GraphQLConfig } from '../../../contexts'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const graphqlConfig: GraphQLConfig = {
  baseURL: `${(process.env.VUE_APP_HTTP_API_BASEURL || '').replace(/^\/|\/$/g, '')}/graphql`,
  headers: {
    'X-Client': process.env.VUE_APP_HTTP_API_CLIENT || ''
  }
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const graphqlConfigDebug: boolean = process.env.VUE_APP_DEBUG_HTTP === 'true'
